
import { axiosClient, getAuthToken as fetchAuthToken, startRequestBlocking, stopRequestBlocking } from '../axios';
import Constants from '../constant';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import {
    getActiveChild,
    getAuthToken,
    getDeviceToken,
    getModal,
    getParent,
    getSavedOtp,
    getSignedInData,
    getUserState,
    setActiveChild,
    setAlertModal,
    setAppConstants,
    setAppCurrentVersion,
    setAuthToken,
    setChildList,
    setDeviceToken,
    setLastLogin,
    setLoginSuccess,
    setOTP,
    setParentProfile,
    setReloadTime,
    setSelectChild,
    setShowOverlay,
    setSupportItem,
    setSurvey,
    setUserState,
} from '../atomstore/serviceAtoms';

import { TransformUserData } from '../components/auth/transform';
import { transformTimeLine } from '../components/home/transformTimeline';
import moment from 'moment';
import { transformChat } from '../components/common/transformChat';
import { transformRequests, transformTabs } from '../components/support/transformRequest';
import axios from 'axios';

const SERVER_DATE_FORMAT = 'YYYY-MM-DD';


//api header
const setApiHeader = (child_id = undefined, parent = undefined) => {
    let header = {
        auth_token: fetchAuthToken(child_id, parent),
        platform: Constants.env.platform,
        app_version: Constants.env.version,
    };
    if (child_id && parent) {
        // header.auth_token = fetchAuthToken(child_id, parent);
        header.child_id = child_id;
        header.parent = parent;
    }
    console.log("Headers", header)
    return header;
};

//Device Info Function
const logDeviceInfo = async () => {
    const info = await Device.getInfo();


    return info;
};


// Forward declaration - will be defined later in the file
let clearSavedTokenCacheRef = null;

const showErrorAlert = (err) => {
    let message = err?.response?.data?.message;
    message = message ? message : err?.message;
    let onOkPressedFn =
        err?.response?.data?.statusCode === 401
            ? async () => {
                setAuthToken('');
                // Clear saved token cache on 401 logout
                if (clearSavedTokenCacheRef) {
                    clearSavedTokenCacheRef();
                }
                await App.removeAllListeners();
                window.location.href = '/login';
            }
            : () => { };
    setAlertModal({
        state: true,
        type: 'Error',
        message: message,
        onOkPressed: onOkPressedFn,
        navigateTo: null,
    });
    return err;
}

//Retrive child info Function
const retrieveChildinfo = activeChild => {
    console.log("id at", activeChild?.center_id)
    return {

        center: activeChild ? activeChild.center_id : null,
        child_id: activeChild ? activeChild?.id : null,
        center_id: activeChild ? activeChild.center_id : null,
        room_id: activeChild ? activeChild.room_id : null,
    };
};

//Login 
export const handleLogin = async (
    form,
    setForm,
    setLoginStep
) => {
    try {
        const activeChildDetail = getActiveChild();
        const parentProfile = getParent();

        let childName = activeChildDetail?.name + activeChildDetail?.lastName;
        const url = `/parentapp/childLoginOTP`;

        console.log(form.email);

        const body = {
            email: form.phone ? '' : form.email?.toLowerCase(),
            phone: form.phone ? form.phone : '',
            verify: '',
            child: childName ? childName : '',
            parent: parentProfile?.parent_name ? parentProfile?.parent_name : '',
            platform: Constants.env.platform,
            app_version: Constants.env.version,
        };

        console.log(
            `[Login] Calling API: /parentapp/childLoginOTP payload `,
            body
        );

        const response = await axiosClient.post(url, body, {
            headers: setApiHeader(),
        });

        console.log(`[Login] Received response: `, response.data);
        if (response.data.status === 'ok') {
            setLoginSuccess(true);
            setLoginStep('otp')
            setOTP(response.data.response);
        } else if (response.data.status === 'error') {
            setForm({ ...form, error: response.data.error });
            setAlertModal({
                state: true,
                type: 'Error',
                message: response.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return response.data;
    } catch (err) {

        let message = err?.response?.data?.message;
        message = message ? message : err?.message;
        setAlertModal({
            state: true,
            type: 'Error',
            message: message,
            navigateTo: null,
            isConfirm: false,
            onOkPressed: () => { },
            onCancelPressed: () => { },
        });
    }
};


//Verify OTP
export const handleVerifyOtp = async (
    form,
    setForm,
    otp,
    otpValue,
    navigate
) => {
    const modal = getModal();
    const otpDetails = JSON.parse(localStorage.getItem("save_otp"))




    try {
        console.log("OTP => ", otpDetails);
        console.log("form", form)
        const signInData = getSignedInData();
        const url = `/parentapp/childLoginViaOTPDetails`;
        const body = {
            otp: otp || otpValue,
            temp_otp: otpDetails.OTP,
            temp_time: otpDetails.time,
            phone: form?.phone,
            email: form?.email,
            platform: Constants.env.platform,
            web: Constants.env.web,
            token: '',
            verify: false,
            aws: 1,
            app_version: Constants.env.version,
        };
        console.log(
            `[Login] Calling API: /parentapp/childLoginViaOTPDetails payload `,
            body
        );
        const response = await axiosClient.post(url, body, {
            headers: setApiHeader(),
        });

        if (response.data.status === 'ok') {
            setLoginSuccess(false);

            const resData = response.data.response;

            // Transform and set all user-related data
            const res = TransformUserData(resData, form?.phone);
            setAuthToken(resData.auth_token);
            setReloadTime(new Date());
            setAppCurrentVersion(resData.app_version);
            setLastLogin(new Date());
            setUserState(res.user);
            setParentProfile(res.parentProfile);
            setChildList(res.childList);
            setActiveChild(res.activeChildDetail);

            // Navigate to survey if available
            if (resData?.survey?.survey_id > 0) {
                setSurvey(resData.survey.survey_id);
                navigate(`/survey/${resData.survey.survey_id}`);
                return;
            }

            // Navigate to default landing page (blogs)
            navigate('/home');

            // Show child overlay if needed
            if (Array.isArray(resData.childList) && resData.childList.length > 1) {
                setSelectChild(true)
            }

            // Show event modal
            if (resData?.eventStatus > 0) {
                setAlertModal({
                    state: true,
                    type: 'Success',
                    message: 'A new event has been scheduled, Click ok to view event details.',
                    navigateTo: '/outdoor-activity',
                    isConfirm: false, // Explicitly set to false for event modals
                    onOkPressed: () => { }, // Clear any old handlers
                    onCancelPressed: () => { },
                });
            }
        }
        else if (response.data.status === 'error') {
            setForm({ ...form, error: response.data.error });
            setAlertModal({
                state: true,
                type: 'Error',
                message: response.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }

        return response.data;
    } catch (err) {
        let message = err?.response?.data?.message;
        message = message ? message : err?.message;
        setAlertModal({
            state: true,
            type: 'Error',
            message: message,
            navigateTo: null,
            isConfirm: false,
            onOkPressed: () => { },
            onCancelPressed: () => { },
        });
    }
};

//Fetch Timeline
export async function fetchChildTimeline(
    startIndex,
    setDataAvailable,
    ChildTimeline,
    ITEM_PER_PAGE,
    include_types,
    setLength,
    setTimeline,
    date
) {
    // console.log('Token ', fetchAuthToken());
    const activeChild = getActiveChild();
    const url = `/parentapp/getChildTimeline`;
    const center = activeChild ? activeChild.center_id : null;
    const child_id = activeChild ? activeChild?.id : null;
    const center_id = activeChild ? activeChild.center_id : null;
    const room_id = activeChild ? activeChild.room_id : null;
    const body = {
        include_types: include_types,
        index_start: startIndex === 0 ? 0 : startIndex + 1,
        limit: ITEM_PER_PAGE,
        // date: moment(date).format(SERVER_DATE_FORMAT)
    };
    console.log(
        `[Child Timeline] Calling API: /parentapp/getChildTimeline payload `, body
    );
    try {
        const res = await axiosClient.post(
            url,
            { ...body, center, center_id, child_id, room_id },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );


        console.log(`[Child Timeline] Received response: `, res.data);
        if (res.data.status === 'ok') {
            let totalTimeline = res.data.response.conversationList;

            setDataAvailable(res.data.response.conversationList.length > 0);
            let transform = transformTimeLine(totalTimeline);

            if (startIndex > 0) {

                transform = ChildTimeline.concat(transform);
            }
            setLength(transform.length);
            setTimeline(transform);
            return transform;
        } else if (res.data.status === 'error') {
            if (startIndex === 0) {
                setTimeline(null)
            }
            let message = res?.data?.message || res?.data?.error;


            setAlertModal({
                state: true,
                type: 'Error',
                message: message,
                navigateTo: null,
            });
        }
        return res.data;
    } catch (err) {
        console.error('Error fetching child timeline:', err);
        showErrorAlert(err);
    }
}

//Get Attendance
export const getAttendance = async () => {
    const activeChild = getActiveChild();
    const url = `/parentapp/getChildAttendance`;
    const body = {
        list: moment().year()
    }
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        //Checking Response
        if (res.data.status === "error") {

            setAlertModal({
                state: true,
                type: 'Error',
                message: res?.data?.error,
                navigateTo: null,
            });

        }
        return res.data.response;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Activity Calender
export const fetchDailyFeed = async (selectedDate) => {
    const activeChild = getActiveChild();
    const url = `/planner/getPlanner`;
    const child = retrieveChildinfo(activeChild);
    let { id, room_id } = child;
    const body = {
        date: moment(selectedDate).format(SERVER_DATE_FORMAT),
        plan_date: [
            moment(selectedDate).format(SERVER_DATE_FORMAT),
            moment(selectedDate).format(SERVER_DATE_FORMAT),
        ],
        plan_type: 'all',
    };
    console.log(
        `[Activity Calendar] Calling API: /planner/getPlanner payload `,
        body
    );

    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );
        console.log(
            `[Activity Calendar] Api Request Response: `,
            res.data
        );
        if (res.data.status === 'ok') {
            const month = moment(selectedDate).format('MMMM');
            return res.data.response.Daily[month];
        }
        else if (res?.data?.status === "error") {

            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Fetch Food
export const fetchFood = async (selectedDate) => {
    const activeChild = getActiveChild();
    const url = `/parentapp/foodMenu`;
    const body = {
        date: moment(selectedDate).format(SERVER_DATE_FORMAT),
    };

    console.log(`[Food Menu] Calling API: /parentapp/foodMenu payload `, body);
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );
        console.log(`[Food Menu] API Request Response: `, res.data);
        if (res.data.status === 'ok') {
            return res.data.response;
        } else {
            return res.data?.error;
        }
    } catch (err) {
        showErrorAlert(err);
    }
};




//Holiday Calender
export const fetchHolidayCalendarData = async () => {
    const activeChild = getActiveChild();
    const url = `/wbsite/getHolidayList`;
    const body = {
        list: moment().year(),
    };
    try {
        const child = retrieveChildinfo(activeChild);
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );



        if (res.data.status !== "error") {
            // return monthWiseHolidays(transformHolidays(res.data));
            return res?.data;

        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res?.data?.error,
                navigateTo: null,
            });
        }
        return res.data
    } catch (err) {
        showErrorAlert(err);
    }
};




//*********** My Center *************/

export const fetchTeachersData = async () => {
    const activeChild = getActiveChild();
    const url = `/userauth/listUsersInRole`;
    const body = {
        roles: ['Teacher', 'Didi'],
    };
    try {
        const child = retrieveChildinfo(activeChild);
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        return res.data.response;
    } catch (err) {
        showErrorAlert(err);
    }
};

export const fetchCenters = async () => {
    const activeChild = getActiveChild();
    const url = `/parentapp/getCenterJSON`;
    const body = {};
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res?.data?.status === "ok") {
            let myCenter = res.data.response.find(
                obj => obj.Center_Id === child.center
            );

            return myCenter;
        } else if (res?.data?.status === "error") {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res?.data?.error,
                navigateTo: null,
            });
            return;
        }


    } catch (err) {
        showErrorAlert(err);
    }
};

//reset door pin
export const resetDoorPin = async () => {
    const activeChild = getActiveChild();
    const user = getUserState();
    const modal = getModal()
    const url = `/userauth/resetDoorPin`;
    const body = {};
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );
        if (res?.data.status === "ok") {
            setUserState({ ...user, password: res.data.door_pin })
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res?.data?.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {

            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }

        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

const PHOTO_LIMIT = 50;

const getFullScreenPhotos = photos => {
    if (Array.isArray(photos)) {
        return photos.map(item => ({
            src: item.message,
            width: 2,
            height: 2,
            thumbnail: item.thumb,
        }));
    }
};

export const fetchPhotos = async (startIndex, photos) => {
    const activeChild = getActiveChild();
    const url = `/parentapp/getConversationList`;
    const body = {
        type: 'photos',
        limit: PHOTO_LIMIT,
        index_start: startIndex,
    };
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            let newphoto = [];
            if (startIndex > 0) {
                newphoto = [...photos, ...res.data.response.photoList];
            } else if (startIndex === 0) {
                newphoto = res.data.response.photoList;
            }

            return getFullScreenPhotos(newphoto);
        } else if (res.data.status === 'error') {
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
            if (res.data.error === 'No Updates.') {
                return photos;
            }
        }
    } catch (err) {
        showErrorAlert(err);
    }
};

export const fetchMeasurement = async () => {
    const activeChild = getActiveChild();
    const url = `/parentapp/measurement`;
    const body = {};

    const child = retrieveChildinfo(activeChild);
    console.log(
        `[Measurement] Calling API: /parentapp/measurement payload `,
        child
    );
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            const yearData = res.data.response.reduce((acc, curr) => {
                let index = acc.findIndex(ele => ele.year == moment(curr?.date).year());
                if (index >= 0) {
                    acc[index].data = [
                        ...acc[index].data,
                        {
                            height: curr.height,
                            weight: curr.weight,
                            month: moment(curr?.date).month(),
                            date: curr.date
                        },
                    ];
                    return acc;
                } else {
                    return [
                        ...acc,
                        {
                            year: moment(curr?.date).year(),
                            data: [
                                {
                                    height: curr.height,
                                    weight: curr.weight,
                                    month: moment(curr?.date).month(),
                                    date: curr.date
                                },
                            ],
                        },
                    ];
                }
            }, []);
            return yearData;
        }
        else if (res?.data?.status === "error") {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res?.data?.error,
                navigateTo: null,
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};



//transform childCare
const transformChildCare = childCare => {
    try {
        if (
            Array.isArray(childCare) &&
            childCare.length > 0 &&
            Array.isArray(childCare[0].description) &&
            childCare[0].description.length > 0
        ) {
            const cCare = childCare.map(item => ({
                ...item,
                ...item.description[0],
            }));

            return cCare;
        }
        return [];
    } catch (error) { }
};


//Childcare data
export const fetchChildCareData = async () => {
    const activeChild = getActiveChild();
    const url = `/parentapp/childCare`;
    const body = {};
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        //Checking Response
        if (res.data.status === 'ok') {
            return transformChildCare(res.data.response);
        }
        else if (res?.data?.status === "error") {
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//fetch chat 
export const fetchChat = async (
    startIndex,
    setMoreData,
    chat,
    setChat,
) => {
    const activeChild = getActiveChild();
    const url = `/parentapp/getConversationList/`;
    const body = {
        index_start: startIndex,
        limit: 50,
    };
    console.log(
        `[Conversation] Calling API: /parentapp/getConversationList payload `,
        body
    );
    const center = activeChild ? activeChild.center_id : null;
    const child_id = activeChild ? activeChild?.id : null;
    const center_id = activeChild ? activeChild.center_id : null;
    const room_id = activeChild ? activeChild.room_id : null;
    try {
        const res = await axiosClient.post(
            url,
            { ...body, center, center_id, child_id, room_id },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        console.log(
            `[Conversation] Api Request Response `,
            res.data
        );
        if (res.data.status === 'ok') {
            setMoreData(res.data.response.moreData);
            let conversationList = res.data.response.conversationList;
            let totalChat = conversationList;


            if (startIndex > 0) {

                setChat([...chat, ...transformChat(totalChat, false)]);
            } else {
                setChat(transformChat(totalChat, false));
            }
        } else if (res?.data?.status === "error") {
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
        }

        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Send Message
export const SendMessage = async (msg, updateState) => {
    const activeChild = getActiveChild();
    const parent = getParent();

    const url = `/parentapp/saveParentMessage`;
    const body = {
        message: msg.trim(),
        parent_email: parent?.parentEmail ? parent.parentEmail : '',
    };
    console.log(
        `[Conversation] Calling API: /parentapp/saveParentMessage payload `,
        body
    );
    const center = activeChild ? activeChild.center_id : null;
    const child_id = activeChild ? activeChild?.id : null;
    const center_id = activeChild ? activeChild.center_id : null;
    const room_id = activeChild ? activeChild.room_id : null;
    try {
        const res = await axiosClient.post(
            url,
            { ...body, center, center_id, child_id, room_id },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );
        console.log(
            `[Conversation] API Request Response `,
            res.data
        );
        if (res.data.status === 'ok') {
            updateState(msg);
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};




//Take A Break
export const handleTakeABreak = async (
    fromDate,
    endDate,
    reason,
    selectedChild,
) => {
    const activeChild = getActiveChild();
    const user = getUserState();
    const parent = getParent();
    const modal = getModal()
    const url = `/parentapp/request`;
    const body = {
        date: moment(fromDate).format(SERVER_DATE_FORMAT),
        end_date: moment(endDate).format(SERVER_DATE_FORMAT),
        attrition_reason: reason,
        child_resume: 'yes',
        child_pause: 'yes',
        values: ['child_resume', 'child_pause'],
        password: user?.password,
        parent_name: parent.parentName,
    };
    const child = retrieveChildinfo(selectedChild);

    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {

            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

let randomNumber = Math.floor(Math.random() * 100);


//Program List
export const fetchProgramList = async (child) => {
    const url = `https://parentapp.s3.ap-southeast-1.amazonaws.com/AppProdConfig.json?version=${randomNumber}`;

    const res = await axiosClient.get(url, {
        headers: setApiHeader(child?.id, child?.parent),
    });

    if (res.data.status === 'ok') {
        return res.data.response.programList; // return only the list
    }

    return res.data;
};


//Change Program
export const submitProgramChange = async (
    selectedDate,
    selectedProgram,
    selectedChild
) => {
    const activeChild = getActiveChild();
    const parent = getParent();
    const modal = getModal();
    const user = getUserState();

    const url = `/parentapp/request`;

    const body = {
        date: moment(selectedDate).format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        attrition_reason: selectedProgram?.time_slot_program_name,
        program_time_slot: selectedProgram?.time_slot,
        center_shift: 'no',
        program_change: 'yes',
        values: ['center_shift', 'program_change'],
        password: user?.password,
        parent_name: parent.parentName,
    };
    try {
        const child = retrieveChildinfo(selectedChild);
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/past-request',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};



//Get Centers
export const fetchCentersShift = async (selectedChild) => {
    const activeChild = getActiveChild();
    const url = `/parentapp/getCenterJSON`;
    const body = {
        // Body content
    };
    try {
        const child = retrieveChildinfo(selectedChild);
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );
        let myCenter = res.data.response.map(obj => {
            return { label: obj.Center_Name, value: JSON.stringify(obj) };
        });
        return myCenter;
    } catch (err) {
        showErrorAlert(err);
    }
};


//fetch Program
export const fetchProgram = async () => {
    const url = `https://parentapp.s3.ap-southeast-1.amazonaws.com/AppProdConfig.json?version=${randomNumber}`;
    const res = await axiosClient.get(url, {});
    if (res.data.status === 'ok') {
        let myCenter = res.data.response.programList;
        return myCenter;
    }
    return res.data;
};

//Shift Center
export const handleShiftCenter = async (
    joiningDate,
    attritionDate,
    selectedCenter,
    selectedProgram,
    selectedChild,
) => {
    const activeChild = getActiveChild();
    const parent = getParent();
    const user = getUserState();
    const modal = getModal();

    const url = `/parentapp/request`;

    const body = {
        date: moment(joiningDate).format('YYYY-MM-DD'),
        end_date: moment(attritionDate).format('YYYY-MM-DD'),
        attrition_reason: selectedCenter
            ? selectedCenter?.Center_Id
            : '',
        center_shift: 'yes',
        program_name: selectedProgram?.time_slot_program_name,
        program_time_slot: selectedProgram?.time_slot,
        program_change: 'no',
        values: ['center_shift', 'program_change'],
        password: user?.password,
        parent_name: parent.parentName,
    };
    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {

            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


export const fetchRequestTypes = async (
    setAllowedServices,
    setType,
    setTabs
) => {
    const activeChild = getActiveChild();

    const url = `/parentapp/getRequestTypes`;
    const body = {};
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        //Checking Response
        if (res.data.status === 'ok') {
            setAllowedServices(res.data.allowed_service);
            const pendingRequests = transformRequests(res.data.pending_requests);
            // setTabs(transformTabs(res.data.allowed_service, pendingRequests));
        } else if (res.data.status === 'error') {
            // Handle error
            setAlertModal({
                state: true,
                type: 'Error',
                message: res?.data?.error,
                navigateTo: null,
            });
        }
        setType(res.data);

        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Change Transport
export const handleChangeTransport = async (
    oneWay,
    selectedDate,
    request,
    selectedChild
) => {
    const activeChild = getActiveChild();
    const parent = getParent();
    const modal = getModal();
    const user = getUserState();



    const url = `/parentapp/request`;
    const body = {
        date: moment(selectedDate).format(SERVER_DATE_FORMAT),
        end_date: moment(selectedDate).format(SERVER_DATE_FORMAT),
        attrition_reason: '',
        password: user?.password,
        parent_name: parent?.parentName,
    };

    if (oneWay === 1) {
        body.one_way_transport =
            request.service_status.Transport1 !=
                "Stop Transport 1 Way"
                ?
                request.service_status.Transport1 !=
                    "Stop Transport 1 Way"
                    ? "yes"
                    : "no"
                : "no";
        body.center_shift = "no";
        body.values = ["one_way_transport", "center_shift"];
    } else {
        body.two_way_transport =
            request.service_status.Transport2 !=
                "Stop Transport 2 Way"
                ?
                request.service_status.Transport2 !=
                    "Stop Transport 2 Way"
                    ? "yes"
                    : "no"
                : "no";;
        body.center_shift = "no";
        body.values = ["two_way_transport", "center_shift"];
    }
    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {

            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);

    }
};

//Withdraw Child
export const handleWithdrawChild = async (
    state,
    selectedChild,
) => {
    const activeChild = getActiveChild();
    const parent = getParent();
    const user = getUserState();
    const modal = getModal();

    const url = `/parentapp/request`;

    const body = {
        date: moment(state.withdrawDate).format(SERVER_DATE_FORMAT),
        end_date: moment().format(SERVER_DATE_FORMAT),
        attrition_reason:
            state.reason === 'Others' ? state.otherRemark : state.reason,
        // only in case of "other" this value is not empty
        password: user?.password,
        parent_name: parent?.parentName,
        center_shift: 'no',
        child_attrition: 'yes',
        values: ['child_attrition', 'center_shift'],
        nps_score: state.rating,
        nps_tags: state.tags.map(item => item.value.key),
        nps_parent: parent?.parentType,
        nps_comments: state.comment,
    };
    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {

            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

//Get Survey Params

export const getSurveyParams = async (selectedChild) => {
    const activeChild = getActiveChild(selectedChild);
    const url = `/parentapp/getSurveyParams`;
    const body = {};
    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );
        if (res.data.status === 'ok') {
            return res.data.response;
        } else if (res.error === 'error') {

        }
    } catch (err) {
        showErrorAlert(err);
    }
};


//Get Fee Certificate
export const handleGetFeeCertificate = async (
    state,
) => {
    const activeChild = getActiveChild();
    const modal = getModal();
    const url = `/financials/getTuitionFeeCertificate`;
    const body = {
        start_date: moment(state.startDate).format(SERVER_DATE_FORMAT),
        end_date: moment(state.endDate).format(SERVER_DATE_FORMAT),
        nature_of_Service: 'Tuition Fee',
    };

    const child = retrieveChildinfo(state?.child);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(state?.child?.id, state?.child?.parent),
            }
        );

        if (res.data.status === 'ok') {

            // navigate('/shareFeeCerticate', { state: { url: res.data.response } });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

//Non-satisfaction refund
export const handleNonSatisfactory = async (
    state
) => {

    const modal = getModal();

    const url = `/financials/saveNonSatisfactionRefund/`;

    const body = {
        refund_date_submit: moment(state.selectedDate).format(SERVER_DATE_FORMAT),
        refund_date: moment().format(SERVER_DATE_FORMAT),
        refund_child_id: state?.child?.id,
        user_id: 0,
        refund_comments: state.comment,
        refund_amount: state.amount,
        show_refund_amount: 'no',
    };
    const child = retrieveChildinfo(state?.child);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(state?.child?.id, state?.child?.parent),
            }
        );

        if (res.data.status === 'ok') {

            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/finance',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


export const sendFeeCertificate = async (
    certificateUrl,
    selectedChild
) => {
    const modal = getModal();
    const user = getUserState();
    const parent = getParent();
    const url = `/parentapp/sendFeeCertificate`;
    const body = {
        email: user?.email,
        name: parent?.parentName,
        url: certificateUrl,
    };

    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            // navigate('/PastRequestTab');
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Free Bee Login
export const freeBeeLogin = async (onSuccess, selectedChild) => {
    const modal = getModal();
    const url = `/chargebees/login`;

    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            {
                id: selectedChild?.id.toString(),
                redirect_url: Constants.env.AppUrl,
                ...child,
            },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            if (onSuccess) onSuccess(res.data);
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Raise Ticket
export const submitIssue = async (
    issue,
    description,
    navigate,
) => {
    const activeChild = getActiveChild();
    const modal = getModal();
    const url = `/parentapp/createTicket`;

    const body = {
        child_name: activeChild?.name + ' ' + activeChild?.last_name,
        branch: activeChild['admission_center_name.name'],
        admissionDate: activeChild?.admission_date,
        email: activeChild?.father_email,
        name: activeChild?.father_name,
        phone: activeChild?.father_phone,
        subject: issue,
        description: description,
    };
    try {
        const child = retrieveChildinfo(activeChild);
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            // navigate('/support');
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

//Get Tickets
export const fetchTickets = async () => {
    const activeChild = getActiveChild();

    const url = `/parentapp/listTickets`;
    const body = {
        email: activeChild?.father_email,
    };
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        //Checking Response
        if (res?.data?.status === "error") {
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
        }
        return res.data.response;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Live CCTV
export const checkCCTVConnectionFunction = async (
    cctvState,
    setCctvState,
    activeChild
) => {
    const url = `${Constants.env.cctvConnectionCheck}`;
    console.log(
        `[Live CCTV] Calling API: ${Constants.env.cctvConnectionCheck}`
    );

    const response = await axiosClient.get(url);
    if (Array.isArray(response.data)) {
        console.log(`[Live CCTV] Received response: `, response.data);
        const userCenterId = activeChild.center_id;
        // const userCenterId = "00";
        const centerDown = response.data.find(item => {
            const isMatched = item.Centre_id === userCenterId;

            return isMatched;
        });
        if (centerDown) {
            setCctvState({ ...cctvState, centerCctvDown: true });
        } else {
            setCctvState({ ...cctvState, centerCctvDown: false });
        }
    }

    return response.data;
};

// Cache last token we successfully sent to backend (in-memory + localStorage)
let LAST_SAVED_TOKEN = null;

// Clear the saved token cache (useful on logout)
export const clearSavedTokenCache = () => {
    console.log("[clearSavedTokenCache] Clearing LAST_SAVED_TOKEN cache");
    LAST_SAVED_TOKEN = null;
    try {
        localStorage.removeItem("last_saved_device_token");
    } catch (e) {
        console.log("[clearSavedTokenCache] Failed to remove last_saved_device_token from localStorage", e);
    }
};

// Set reference for use in showErrorAlert (to avoid circular dependency issues)
clearSavedTokenCacheRef = clearSavedTokenCache;

export const saveToken = async (token) => {
    try {
        const activeChild = getActiveChild();
        const signInData = getSignedInData();
        console.log("Signed in Data", signInData);

        // Always rely on the canonical stored device token
        const currentToken = getDeviceToken();

        // If we have no token, or we already saved this exact token for this session, skip
        if (!currentToken) {
            console.log("[saveToken] No device token found, skipping save.");
            return;
        }

        if (LAST_SAVED_TOKEN === currentToken) {
            console.log("[saveToken] Token already saved in this session, skipping.");
            return;
        }

        const url = `/parentapp/saveToken`;
        const info = await logDeviceInfo();
        const body = {
            child_id: activeChild?.id,
            platform: Constants.env.platform,
            token: currentToken,
            app_version: Constants.env.version,
            web: Constants.env.web,
            parent: activeChild?.parent,
            device_Modal: `${info?.manufacturer} ${info?.model}`,
            device_os: `${info?.operatingSystem} ${info?.osVersion}`,
            email: signInData?.email ? signInData?.email : activeChild.parent === "Mother"
                ? activeChild?.mother_email
                : activeChild?.father_email
        };

        const response = await axiosClient.post(url, body, {
            headers: setApiHeader(),
        });

        if (response.data.status === "error") {
            console.log("[saveToken] Backend returned error while saving token:", response.data);
        } else {
            // Remember that we have already sent this token successfully
            LAST_SAVED_TOKEN = currentToken;
            try {
                localStorage.setItem("last_saved_device_token", currentToken);
            } catch (e) {
                console.log("[saveToken] Failed to persist last_saved_device_token", e);
            }
        }

        return response.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Reload API
export const ReloadData = async () => {
    try {
        // Start blocking all other requests
        startRequestBlocking();

        const activeChild = getActiveChild();
        const user = getUserState();
        console.log("user", user)
        console.log("activechild", activeChild)
        const url = `/parentapp/childLoginReloadDetails`;

        const body = {
            child_id: activeChild?.id,
            otp: '',
            temp_otp: '',
            temp_time: '',
            phone: user?.phone,
            email: user?.email,
            platform: Constants.env.platform,
            web: Constants.env.web,
            token: '',
            verify: false,
            aws: 1,
            app_version: Constants.env.version,
        };

        const response = await axiosClient.post(url, body, {
            headers: setApiHeader(),
        });

        console.log("Response from reload", response)
        if (response.data.status === 'ok') {
            if (response.data?.response.activeChildDetail.login_status == '0') {

                setAuthToken('');
                setReloadTime('');
                // User will be redirected to /login by route protection
            }
            if (
                response.data?.response &&
                response.data?.response.survey &&
                response.data?.response.survey.survey_id > 0
            ) {

                setSurvey(response.data?.response?.survey?.survey_id);
                // navigation to /survey handled by Reload component using survey_id
            }
            if (response?.data?.response?.eventStatus > 0) {
                setAlertModal({
                    state: true,
                    type: 'Success',
                    message: 'A new event has been scheduled, Click ok to view event details.',
                    navigateTo: '/outdoor-activity',
                    isConfirm: false, // Explicitly set to false for event modals
                    onOkPressed: () => { }, // Clear any old handlers
                    onCancelPressed: () => { },
                });
            }
            if (getDeviceToken()) {
                saveToken(getDeviceToken());
            }
            setAuthToken(response?.data?.response?.auth_token);
            setReloadTime(new Date());
            setAppCurrentVersion(response?.data?.response?.app_version);
            const res = TransformUserData(response.data.response, '');
            setUserState(res.user);
            setParentProfile(res.parentProfile);
            setChildList(res.childList);
            setActiveChild(res.activeChildDetail);
        } else if (response.data.status === 'error') {

            let message = response?.data?.message || response?.data?.error;
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: message,
            // });
        }

        // Stop blocking requests after reload completes
        stopRequestBlocking();
        return response.data;
    } catch (err) {
        // Stop blocking requests even if there's an error
        stopRequestBlocking();
        showErrorAlert(err);
        throw err;
    }
};

// Check Policy Status
export const checkPolicyStatus = async () => {
    const activeChild = getActiveChild();
    if (!activeChild?.id) {
        console.error("[checkPolicyStatus] No active child found");
        return null;
    }

    const url = `/franchises/checkPolicyStatus?child_id=${activeChild.id}`;

    console.log(`[checkPolicyStatus] Calling API: ${url}`);

    try {
        const res = await axiosClient.get(url, {
            headers: setApiHeader(activeChild?.id, activeChild?.parent),
        });

        console.log(`[checkPolicyStatus] API Response:`, res.data);

        // Parse the response if it's a string
        let responseData = res.data;
        if (typeof res.data === 'string') {
            try {
                responseData = JSON.parse(res.data);
            } catch (e) {
                console.error("[checkPolicyStatus] Error parsing response:", e);
                return null;
            }
        }

        if (responseData.status === 'ok') {
            return responseData.data;
        } else {
            console.error("[checkPolicyStatus] Error:", responseData.error);
            return null;
        }
    } catch (err) {
        console.error("[checkPolicyStatus] API Error:", err);
        showErrorAlert(err);
        return null;
    }
};

// Accept Policy
export const acceptPolicy = async () => {
    const activeChild = getActiveChild();
    if (!activeChild?.id) {
        console.error("[acceptPolicy] No active child found");
        return null;
    }

    const url = `/parentapp/acceptPolicy?child_id=${activeChild.id}`;

    console.log(`[acceptPolicy] Calling API: ${url}`);

    try {
        const res = await axiosClient.post(url, {}, {
            headers: setApiHeader(activeChild?.id, activeChild?.parent),
        });

        console.log(`[acceptPolicy] API Response:`, res.data);

        // Parse the response if it's a string
        let responseData = res.data;
        if (typeof res.data === 'string') {
            try {
                responseData = JSON.parse(res.data);
            } catch (e) {
                console.error("[acceptPolicy] Error parsing response:", e);
                return null;
            }
        }

        return responseData;
    } catch (err) {
        console.error("[acceptPolicy] API Error:", err);
        showErrorAlert(err);
        return null;
    }
};

export const fetchPastRequests = async () => {
    const activeChild = getActiveChild();
    const url = `/parentapp/requestList`;
    const body = {};
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        //Checking Response
        if (res.data.status === 'ok') {
            const transformedRequests = res.data.response.map(request => {
                let showCancel = false;
                let showEarlyPauseAndResume = false;
                if (
                    (request.type === 'Leaves' || request.type === 'Child Pause') &&
                    (request.status === 'Approved' ||
                        request.status === 'Pending' ||
                        request.status === 'Processing') &&
                    moment(request.date).isAfter('2017-04-01') &&
                    moment().isBefore(
                        moment(request.end_date, 'YYYY-MM-DD').add(1, 'days')
                    )
                ) {
                    showEarlyPauseAndResume = true;
                }
                if (
                    (request.type === 'Leaves' || request.type === 'Child Pause') &&
                    request.status === 'Pending' &&
                    moment().isBefore(request.date)
                ) {
                    showCancel = true;
                    showEarlyPauseAndResume = false;
                } else if (
                    (request.type === 'Add One Way Transport' ||
                        request.type === 'Add Two Way Transport') &&
                    (request.status === 'Processing' || request.status === 'Pending')
                ) {
                    showCancel = true;
                } else if (
                    request.type === 'Center Shift' &&
                    request.status === 'Pending'
                ) {
                    showCancel = true;
                } else if (
                    request.type === 'Program Change' &&
                    (request.status === 'Pending' || request.status === 'Processing')
                ) {
                    showCancel = true;
                } else if (
                    request.type === 'Child Attrition' &&
                    (request.status === 'Pending' || request.status === 'Processing')
                ) {
                    showCancel = true;
                } else if (
                    (request.type === 'Delete One Way Transport' ||
                        request.type === 'Delete Two Way Transport') &&
                    (request.status === 'Pending' || request.status === 'Processing')
                ) {
                    showCancel = true;
                } else if (
                    request.type === 'Extended Daycare' &&
                    (request.status === 'Pending' || request.status === 'Processing')
                ) {
                    showCancel = true;
                } else {
                    showCancel = false;
                }

                const transformedRequest = {
                    ...request,
                    showCancel,
                    showEarlyPauseAndResume,
                };
                return transformedRequest;
            });
            return transformedRequests;
        } else if (res.data.status === 'error') {
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
        }
        return res.data.response;
    } catch (err) {
        showErrorAlert(err);
    }
};


export const cancelPauseRequest = async (
    request_id
) => {
    const activeChild = getActiveChild();
    const modal = getModal();
    const url = `/admission/cancelChildPauseRequest`;
    const body = {
        admission_id: activeChild?.id,
        request_id: request_id,
        end_date: moment().format(SERVER_DATE_FORMAT),
    };

    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            // refetch()
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
            // return res.data;
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
            // return res.data;
        }
        // return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

//cancel Leave

export const cancelLeaveRequest = async (
    request_id,
) => {
    const activeChild = getActiveChild();
    const modal = getModal();
    const url = `/admission/cancelChildPauseRequest`;
    const body = {
        admission_id: activeChild?.id,
        request_id: request_id,
        end_date: moment().format(SERVER_DATE_FORMAT),
    };

    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            // refetch()
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


//Cancel All Req

export const cancelRequest = async (
    request_id
) => {
    const activeChild = getActiveChild();
    const modal = getModal();
    const url = `/financials/cancelCustomerRequest`;
    const body = {
        admission_id: activeChild?.id,
        request_id: request_id,
        end_date: moment().format(SERVER_DATE_FORMAT),
    };

    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            // refetch()
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


export const submitExtendedDaycare = async (
    selectedDate,
    serviceDuration, selectedChild
) => {
    const activeChild = getActiveChild();
    const user = getUserState();
    const parent = getParent();
    const modal = getModal();
    const url = `/parentapp/request`;

    const body = {
        date: moment(selectedDate).format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        attrition_reason: serviceDuration,
        center_shift: 'no',
        extended_daycare: 'yes',
        values: ['center_shift', 'extended_daycare'],
        password: user?.password,
        parent_name: parent.parentName,
    };
    const child = retrieveChildinfo(selectedChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
            }
        );

        if (res.data.status === 'ok') {

            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};



//Early Resume

export const resumeFromBreak = async (
    requestId,
    selectedDate,
    navigate,
) => {
    const activeChild = getActiveChild();
    const modal = getModal();

    const url = `/franchises/resumeChild`;
    const body = {
        req_id: requestId,
        early_resume_date: moment(selectedDate).format(
            SERVER_DATE_FORMAT,
            'YYYY-MM-DD'
        ),
    };
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

//Extend Pause
export const extendPause = async (
    requestId,
    selectedDate,
) => {
    const activeChild = getActiveChild();
    const modal = getModal();

    const url = `/franchises/pauseChild/`;
    const body = {
        req_id: parseInt(requestId),
        extend_date: moment(selectedDate).format(SERVER_DATE_FORMAT),
    };
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: '/support',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                message: res.data.error,
                navigateTo: null,
                isConfirm: false,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

//Fetch Constants
export async function fetchConstants() {
    try {
        const res = await axios.get(Constants.env.filePath);
        if (res.data.status === 'ok') {
            setAppConstants(res.data.response);
            return res.data.response;
        } else if (res.data.status === 'error') {
        }
        return res.data;
    } catch (error) {
        throw error;
    }
}





//Submit Survey

export const submitSurvey = async (
    state,
) => {

    console.log("state", state)
    const activeChild = getActiveChild();
    const modal = getModal();
    const parent = getParent();
    const url = `/parentapp/updateParentFeedback`;
    const body = {
        nps_score: state.rating,
        nps_tags: state.tags.map(item => item.value.key),
        nps_parent: parent.parentType,
        nps_comments: state.comment,
        survey_id: state?.surveyId,
    };

    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            setSurvey(-1);
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: "Survey submitted successfully",
                navigateTo: '/home',
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setSurvey(-1);
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


export const fetchNews = async (selectedMonth) => {
    const activeChild = getActiveChild();
    const url = `/parentapp/getNewLetters`;
    const body = {
        month: selectedMonth?.month,
        year: selectedMonth?.year
    };
    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            if (Array.isArray(res.data.response) && res.data.response.length > 0) {
                return res.data.response.map(item => {
                    return {
                        ...item,
                        newsletter_due_date: moment(item.newsletter_due_date).format(
                            'DD MMMM, YYYY'
                        ),
                    };
                });
            }
            return [];
        } else if (res.data.status === 'error') {
            // setAlertModal({
            //     state: true,
            //     type: 'Error',
            //     message: res?.data?.error,
            // });
            return [];
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


// Outdoor Activity
export const fetchOutdoorActivity = async () => {
    const activeChild = getActiveChild();
    const parent = getParent();

    const parentType = parent.parentType.toLowerCase();
    const url = `/centerevents/my_events`;
    const body = {
        consent_by: parentType,
    };
    let child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            return res.data.response;
        } else if (res.data.status === 'error') {
            return [];
            // Handle error if needed
            // setAlertModal({
            //   state: true,
            //   type: 'Error',
            //   message: res?.data?.error,
            // });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};

export const eventAction = async (
    eventId,
    status
) => {
    // console.log("eventAction", eventId, status);
    const activeChild = getActiveChild();
    const modal = getModal();
    const parent = getParent();
    const consent_by = parent?.parentType;
    const url = `/centerevents/event_act`;
    const body = {
        event_id: eventId,
        consent_by: consent_by,
        status,
    };

    const child = retrieveChildinfo(activeChild);
    try {
        const res = await axiosClient.post(
            url,
            { ...body, ...child },
            {
                headers: setApiHeader(activeChild?.id, activeChild?.parent),
            }
        );

        if (res.data.status === 'ok') {
            setAlertModal({
                state: true,
                type: 'Success',
                isConfirm: false,
                message: res.data.message,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        } else {
            setAlertModal({
                state: true,
                type: 'Error',
                isConfirm: false,
                message: res.data.error,
                navigateTo: null,
                onOkPressed: () => { },
                onCancelPressed: () => { },
            });
        }
        return res.data;
    } catch (err) {
        showErrorAlert(err);
    }
};


export const getUnpaidInvoices = async (child) => {
    const url = `/financials/checkDuePayment`;
    try {
        const res = await axiosClient.get(url, {
            params: {
                child_id: child?.id,
            },
            headers: setApiHeader(child?.id, child?.parent),
        });

        console.log(res);
        if (res.data.status === 'ok') {
            return res.data.response
        } else if (res.data.status === 'error') {

        }

        return res.data;
    } catch (err) {
        showErrorAlert(err);
        return [];
    }
};

//fetch center program list 
export const fetchCenterProgramTimeSlots = async (selectedChild) => {


    const url = `/userauth/getCenterProgramTimeSlots`;

    try {
        const child = retrieveChildinfo(selectedChild);

        const res = await axiosClient.get(url, {
            params: {
                child_id: child?.child_id || selectedChild?.id,
            },
            headers: setApiHeader(selectedChild?.id, selectedChild?.parent),
        });

        console.log("response of timelsot API", res)
        if (res.data.status === "ok") {
            return res.data?.response
        }

    } catch (err) {
        showErrorAlert(err);
    }
};